import "../Section.css";
import { jsxs, jsx } from "react/jsx-runtime";
import { useTheme } from "./Theme/UI.js";
import "./Theme/themeUtils.js";
import "./Theme/themes.js";
const base = "Section_base_cab96";
const header = "Section_header_cab96";
const title = "Section_title_cab96";
const string = "Section_string_cab96";
const body = "Section_body_cab96";
const fullHeight = "Section_fullHeight_cab96";
const titleDivider = "Section_titleDivider_cab96";
const css = {
  base,
  header,
  title,
  string,
  body,
  fullHeight,
  titleDivider
};
const Section = ({
  children,
  fullHeight: fullHeight2 = false,
  titleDivider: titleDivider2 = false,
  title: title2
}) => {
  const {
    themeSettings: { className }
  } = useTheme();
  const classes = [className, css.base];
  const titleClasses = [css.title];
  if (titleDivider2 && title2)
    classes.push(css.titleDivider);
  if (fullHeight2)
    classes.push(css.fullHeight);
  if (typeof title2 === "string")
    titleClasses.push(css.string);
  return /* @__PURE__ */ jsxs("section", { className: classes.join(" "), children: [
    !!title2 && /* @__PURE__ */ jsx("div", { className: css.header, children: /* @__PURE__ */ jsx("h5", { className: titleClasses.join(" "), children: title2 }) }),
    /* @__PURE__ */ jsx("div", { className: css.body, children })
  ] });
};
export {
  Section as default
};
